import { render } from "./voting-instructions-card.vue?vue&type=template&id=1020eafa"
import script from "./voting-instructions-card.vue?vue&type=script&lang=js"
export * from "./voting-instructions-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__